/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./accountMgmtUserDetails.vue?vue&type=template&id=35dbf727&scoped=true"
import script from "./accountMgmtUserDetails.vue?vue&type=script&lang=js"
export * from "./accountMgmtUserDetails.vue?vue&type=script&lang=js"
import style0 from "./accountMgmtUserDetails.vue?vue&type=style&index=0&id=35dbf727&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dbf727",
  null
  
)

export default component.exports